// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_Zo4","cls2":"JJHomePageSearch-cls2_Rpe JJHomePageSearch-cls1_Zo4","spin":"JJHomePageSearch-spin_2jR"};